module.exports = __webpack_public_path__ + "static/media/barcode.fr.96257ace.png";